<template>
  <div class="monthlist">
    <div>
      <div class="u-time">
        <div class="f-dfa">
          <div>
            <van-icon name="arrow-left"
                      @click="lf()" />
          </div>
          <div class="date"
               @click="show = true;">{{date}}</div>
          <div>
            <van-icon name="arrow"
                      @click="rg()" />
          </div>
        </div>

      </div>
      <van-popup v-model="show"
                 position="bottom">
        <!-- <van-datetime-picker show-toolbar
                           title="选择时间"
                           v-model="currentDate"
                           type="year-month"
                           :min-date="minDate"
                           :max-date="maxDate"
                           @confirm="onConfirm"
                           @cancel="onCancel" /> -->
        <van-datetime-picker v-model="currentDate"
                             type="year-month"
                             title="选择时间"
                             :min-date="minDate"
                             :max-date="maxDate"
                             @confirm="onConfirm"
                             @cancel="onCancel" />
      </van-popup>

    </div>
    <div v-show="tab===1"
         class="con">
      <van-row class="nav">
        <van-col span="8"
                 class="navlf">
          <span class="navdate">{{list1.labourCostMonthTotal/10000 | moneyP}}W</span>
          <span class="navtext">劳务</span>
        </van-col>
        <van-col span="8"
                 class="navlf">
          <span class="navdate">{{list1.materialCostMonthTotal/10000 | moneyP}}W</span>
          <span class="navtext">材料及其他</span>
        </van-col>
        <van-col span="8">
          <span class="navdate">{{list1.machineCostMonthTotal/10000 | moneyP}}W</span>
          <span class="navtext">机械</span>
        </van-col>
      </van-row>
      <van-row class="nav">
        <van-col span="12"
                 class="navlf">
          <span class="navdate">{{list1.totalCostMonthTotal/10000 | moneyP}}W</span>
          <span class="navtext">本月合计</span>
        </van-col>
        <van-col span="12">
          <span class="navdate">{{list1.lastMonthAccumulatedCostTotal/10000 | moneyP}}W</span>
          <span class="navtext">上期累计</span>
        </van-col>

      </van-row>
      <div class="danwei">
        <span>单位：万(W)&nbsp;</span>
      </div>
      <table class="t-data"
             cellpadding='6'
             cellspacing='0'>
        <thead>
          <tr>
            <th class="xmmc">项目名称</th>
            <th class="lw">劳务</th>
            <th class="cl">材料及其他</th>
            <th class="jx">机械</th>
            <th class="hj">合计</th>
          </tr>
        </thead>
        <tbody class="t-body">
          <tr v-for="(table1,index) in list1.monthProjectCostItems"
              :key="index"
              :class="color(table1.reportStatus)">
            <td class="xmmc-wid">{{table1.itemName}}</td>
            <td class="jq-wid">{{table1.labourCost/10000 | moneyP}}</td>
            <td class="jq-wid">{{table1.materialCost/10000 | moneyP}}</td>
            <td class="jq-wid">{{table1.machineCost/10000 | moneyP}}</td>
            <td class="jq-wid">{{table1.totalCost/10000 | moneyP}}</td>
          </tr>
        </tbody>
      </table>

    </div>

    <div v-show="tab===2"
         class="con">
      <div class="projectCost">
        <div class="container">

          <!-- 总计和折线图 -->
          <div class="wrapper">

            <div style="display:flex">
              <div style="width:1.07vw;
                          height:4vw;
                          margin-left: 7.3vw;
                          background-color:#477AFF;">
              </div>
              <div style="font-size: 4vw;
                          margin-top:-0.8vw;
                          margin-left:2.67vw;
                          font-family: Source Han Sans CN;
                          font-weight: 400;
                          color: #4C4C4C;
                          text-align:left">
                {{total.price.name}}
              </div>
            </div>
            <div style="font-size: 3vw;
                          line-height: 6.7vw;
                          margin-left: 11.1vw;
                          color: #8F8F8F;
                          text-align: left;">
              近6月收入(万)
            </div>
            <div id="roseChartto"></div>
          </div>
          <!-- 每个项目的循环折线图 -->
          <div class="wrapper"
               v-for="(item,index) in list.slice(0,list.length-1)"
               :key="index">
            <div style="display:flex">
              <div style="width:1.07vw;
                          height:4vw;
                          margin-left: 7.3vw;
                          background-color:#477AFF;">
              </div>
              <div v-text="list[index].price.name"
                   style="font-size: 4vw;
                          margin-top:-0.8vw;
                          margin-left:2.67vw;
                          font-family: Source Han Sans CN;
                          font-weight: 400;
                          color: #4C4C4C;
                          text-align:left">
              </div>
            </div>
            <div style="font-size: 3vw;
                          line-height: 6.7vw;
                          margin-left: 11.1vw;
                          color: #8F8F8F;
                          text-align: left;">
              近6月收入(万)
            </div>
            <div class="roseChart"></div>
          </div>
        </div>
      </div>

    </div>

    <ul class="list-box">
      <li :class="{cur:tab===1}"
          @click="tab=1">
        月统计
      </li>
      <li :class="{cur:tab===2}"
          @click="tab=2">
        趋势图
      </li>
    </ul>

  </div>
</template>

<script>
import { ylrc } from '@/axios/api'
import { Toast } from 'vant'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'monthlist',
  computed: {
    ...mapGetters(['token'])
  },
  watch: {
    token: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.run()
        }
      }
    }
  },
  data() {
    return {
      tab: 1,
      list: [],
      list1: [],
      total: {
        id: '',
        price: {
          name: ''
        }
      },
      color: function(stus) {
        if (stus != null) {
          return 'grey'
        }
      },
      date: this.$route.query.month,
      show: false,
      minDate: new Date(2021, 7),
      maxDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1),
      currentDate: new Date(new Date() - 86400000)
    }
  },

  methods: {
    jumpUrl(url) {
      if (url) {
        //var newUrl = url+"?date="+this.date;
        var newUrl = url.replace('yyyyMMdd', this.date)
        this.show2 = false
        window.location.href = newUrl
      } else {
        alert('报表路径有误，无法查看')
      }
    },
    async getDaily(date) {
      let res = await ylrc.getDaily(date)
      this.list1 = res
    },
    onConfirm(picker, value, index) {
      this.show = false
      let year = this.currentDate.getFullYear()
      let month = this.currentDate.getMonth() + 1
      this.date = year + '-' + this.add(month)
      this.run()
    },
    onCancel() {
      this.show = false
    },
    add(num) {
      if (num < 10) return '0' + '' + num
      else return num
    },
    lf() {
      let date = this.date
      var arr = date.split('-')
      var year = arr[0] //获取当前日期的年份
      var month = arr[1] //获取当前日期的月份
      var year2 = year
      var month2 = parseInt(month) - 1
      if (month2 == 0) {
        year2 = parseInt(year2) - 1
        month2 = 12
      }

      var mdate = new Date(year2, this.add(month2)) - this.minDate
      if (mdate > 0) {
        this.date = year2 + '-' + this.add(month2)
        this.run()
      } else {
        Toast.fail('无法选择更早的时间')
      }
    },
    rg() {
      let date = this.date
      var arr = date.split('-')
      var year = arr[0] //获取当前日期的年份
      var month = arr[1] //获取当前日期的月份
      var year2 = year
      var month2 = parseInt(month) + 1
      if (month2 == 13) {
        year2 = parseInt(year2) + 1
        month2 = 1
      }
      var mdate =
        new Date(year2, this.add(month2)) -
        new Date(new Date().getFullYear(), new Date().getMonth())

      if (mdate <= 0) {
        this.date = year2 + '-' + this.add(month2)
        this.run()
      } else {
        Toast.fail('无法选择更晚的时间')
      }
    },
    async getMonth(month) {
      let res = await ylrc.getMonth(month)
      this.list1 = res

      /* console.log(this.list1.monthProjectCostItems) */
    },

    async getMonthTrend(month) {
      let res = await ylrc.getMonthTrend(month)
      /* console.log(res) */
      let arr = res.monthProjectCostTrend
      let list2 = []
      /**循环获取的二维数组 （单次循环 方便获取二位数组中的数据） */
      arr.map((item, index) => {
        /**总的object */
        let objAll = {}
        /**存二维数组中循环以后的数组key跟value */
        let obj = {}
        // 因为之前写死的数据里存了五个变量所以需要五个变量(数组)接收
        let monthar = []
        let hjar = []
        let lwar = []
        let clar = []
        let jxar = []
        // 循环二维数组中的数组(拿数据) 这样就能获取到二维数组中的val
        item.map(m => {
          /**因为之前写死的数据里存了五个变量所以需要五个变量(数组)接收 */
          monthar.push(m.month.substr(5, 2))
          hjar.push(m.totalCost / 10000)
          lwar.push(m.labourCost / 10000)
          clar.push(m.materialCost / 10000)
          jxar.push(m.machineCost / 10000)
        })
        /**因为之前写死的数据里存了五个变量所以需要五个变量(数组)接收 */
        /**接收完以后 存到一个数组中 */
        obj['month'] = monthar
        obj['hj'] = hjar
        obj['lw'] = lwar
        obj['cl'] = clar
        obj['jx'] = jxar
        /** 因为写的死数据里带着name 所以随便拿一个name就可以 [0]就简单 */
        obj['name'] = item[0].itemName
        /** 因为写的死数据里带着id 所以要拿到下标index +1是为了不显示0*/
        objAll['id'] = index + 1
        // 对象拼接price为刚才合并的obj对象
        objAll['price'] = obj
        // 把每一条对象 objAll 添加到数组中
        list2.push(objAll)
      })
      // 赋值
      this.list = list2
      this.total = this.list[this.list.length - 1]

      //nextTick()，是将回调函数延迟在下一次dom更新数据后调用
      //简单的理解是：当数据更新了，在dom中渲染后，自动执行该函数，
      this.$nextTick(() => {
        this.drawRose1()
        this.drawRose()
      })
    },
    /* 折线图 */
    drawRose1() {
      var echarts = require('echarts')
      var roseChartto = document.getElementById('roseChartto')
      var myChartto = echarts.init(roseChartto)

      myChartto.setOption({
        color: ['#5584FF', '#F8333C', '#44AF69', '#FCAB10'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                '<br/>' +
                params[i].marker +
                params[i].seriesName +
                ' : ' +
                params[i].value.toFixed(2) +
                '万'
            }
            return relVal
          }
        },

        legend: {
          data: ['劳务', '材料及其他', '机械', '合计']
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: '月',
          nameTextStyle: {
            padding: [0, 0, -25, -10]
          },
          data: this.total.price.month
        },
        yAxis: [
          {
            type: 'value',
            /* name: '/万元', */
            position: 'left',
            splitLine: {
              show: false
            },
            axisTick: {
              inside: true
            }
            /* axisLabel: {
                formatter: function(value, index) {
                  if (value >= 0) {
                    value = value / 10000
                  }
                  return value
                }
              } */
          },
          {
            type: 'value',
            name: '合计',
            position: 'right',

            axisLine: {
              show: true,
              lineStyle: {
                color: '#5584FF'
              }
            },
            splitLine: {
              show: false
            }
            /*   axisLabel: {
                formatter: function(value, index) {
                  if (value >= 0) {
                    value = value / 10000
                  }
                  return value
                }
              } */
          }
        ],

        series: [
          {
            name: '合计',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 5
              }
            },

            barWidth: 12, //  控制柱子的宽度
            data: this.total.price.hj // 渲染每个图表对应的数据
          },
          {
            name: '劳务',
            type: 'line',
            data: this.total.price.lw // 渲染每个图表对应的数据
          },
          {
            name: '材料及其他',
            type: 'line',
            data: this.total.price.cl // 渲染每个图表对应的数据
          },
          {
            name: '机械',
            type: 'line',
            data: this.total.price.jx // 渲染每个图表对应的数据
          }
        ]
      })
      /* console.log(this.total) */
    },

    drawRose() {
      var echarts = require('echarts')
      var roseCharts = document.getElementsByClassName('roseChart') // 对应地使用ByClassName

      for (var i = 0; i < roseCharts.length; i++) {
        // 通过for循环，在相同class的dom内绘制元素
        var myChart = echarts.init(roseCharts[i])
        myChart.setOption({
          color: ['#5584FF', '#F8333C', '#44AF69', '#FCAB10'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function(params) {
              var relVal = params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  '<br/>' +
                  params[i].marker +
                  params[i].seriesName +
                  ' : ' +
                  params[i].value.toFixed(2) +
                  '万'
              }
              return relVal
            }
          },

          legend: {
            data: ['劳务', '材料及其他', '机械', '合计']
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            name: '月',
            nameTextStyle: {
              padding: [0, 0, -25, -10]
            },
            data: this.list[i].price.month
          },
          yAxis: [
            {
              type: 'value',
              /* name: '/万元', */
              position: 'left',
              splitLine: {
                show: false
              },
              axisTick: {
                inside: true
              }
              /* axisLabel: {
                formatter: function(value, index) {
                  if (value >= 0) {
                    value = value / 10000
                  }
                  return value
                }
              } */
            },
            {
              type: 'value',
              name: '合计',
              position: 'right',

              axisLine: {
                show: true,
                lineStyle: {
                  color: '#5584FF'
                }
              },
              splitLine: {
                show: false
              }
              /*   axisLabel: {
                formatter: function(value, index) {
                  if (value >= 0) {
                    value = value / 10000
                  }
                  return value
                }
              } */
            }
          ],

          series: [
            {
              name: '合计',
              type: 'bar',
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  barBorderRadius: 5
                }
              },

              barWidth: 12, //  控制柱子的宽度
              data: this.list[i].price.hj // 渲染每个图表对应的数据
            },
            {
              name: '劳务',
              type: 'line',
              data: this.list[i].price.lw // 渲染每个图表对应的数据
            },
            {
              name: '材料及其他',
              type: 'line',
              data: this.list[i].price.cl // 渲染每个图表对应的数据
            },
            {
              name: '机械',
              type: 'line',
              data: this.list[i].price.jx // 渲染每个图表对应的数据
            }
          ]
        })
      }
    },
    run() {
      this.getMonth(this.date)
      this.getMonthTrend(this.date)
    }
  },
  mounted() {
    /* this.run() */
    /* this.drawRose() */
  }
}
</script>

<style lang="less" scoped>
body {
  background-color: #ffffff;
  height: 100%;
  .f-dfa {
    display: flex;
    align-items: center;
  }
  .u-time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4vw;
    background: #5584ff;
    color: #fff;
  }
  .date {
    display: flex;
    align-items: center;
    margin: 0 2vw;
  }
  .bb {
    margin-right: 1vw;
  }
  .popup-list {
    padding: 4vw;
    height: 94vw;
    overflow-y: scroll;
    border-radius: 12px 12px 0 0;
    box-sizing: border-box;
  }
  .popup-list .itembox {
    padding: 2vw 0;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
  }
  .popup-list .itembox:last-child {
    border-bottom: none;
  }
  .popup-list .itemname {
    padding: 4vw 2vw 2vw 2vw;
    font-size: 18px;
    font-weight: 700;
    text-align: left;
  }
  .popup-list .item {
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 8vw;
    margin: 2vw;
    padding: 2vw 4vw;
    font-size: 16px;
    background: #f1f1f1;
    color: #5f7091;
    border-radius: 60px;
  }
}
.con {
  padding-bottom: 13vw;
}

.grey {
  background-color: #e2eafe;
}
.nav {
  border-top: 1px solid #c4d2f6;
  background: #5584ff;
  padding-top: 4vw;
  padding-bottom: 4.5vw;
}
.navlf {
  border-right: 1px solid #c4d2f6;
}
.navdate {
  display: block;
  color: #ffffff;
  font-size: 4.23vw;
  font-family: Source Han Sans CN;
  font-weight: bold;
}
.navtext {
  color: #c4d2f6;
  font-size: 3.47vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
}

.t-data {
  font-size: 3.47vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #2c2c2c;
  thead {
    background-color: #e2eafe;
  }

  .t-body {
    background-color: #ffffff;
    td {
      border-bottom: silver;
      border: none;
    }
    .xmmc-wid {
      text-align: left;
      width: 30vw;
    }
    .jq-wid {
      width: 17.5vw;
    }
  }
}

.danwei {
  background-color: #ffffff;
  height: 8vw;
  display: flex;
  align-items: center;
  span {
    height: 3.47vw;
    font-size: 3.47vw;
    font-family: Source Han Sans CN;
    font-weight: 400;
    margin-left: auto;
  }
}

.list-box {
  width: 100%;
  height: 13vw;
  background-color: #ffffff;
  border-top: 1px solid #efefef;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  li {
    width: 26.7vw;
    height: 9.5vw;
    line-height: 9.5vw;
    border-radius: 6px;
    text-align: center;
    font-size: 3.73vw;
  }
}

.cur {
  background: #5584ff;
  color: #ffffff;
}

.projectCost {
  width: 100vw;
  .container {
    width: 100vw;

    background-size: 100% 100%;
    .wrapper {
      margin-top: 2.67vw;
      margin-left: 2.67vw;
      width: 95vw;
      height: 62.27vw;
      background-color: #ffffff;
      padding-top: 3.7vw;
      .roseChart {
        margin-left: 7.3vw;
        width: 80vw;
        height: 48vw;
      }
    }
  }
}
#roseChartto {
  margin-left: 7.3vw;
  width: 80vw;
  height: 48vw;
}
</style>





// WEBPACK FOOTER //
// src/ylrc/monthList.vue